export default () => {
  const incidentTypeHasOverdose = $(
    "#incident_report_incident_is_medical_emergency_subtype_overdose_not_death"
  );
  const incidentTypeHasOverdoseDeath = $(
    "#incident_report_incident_is_medical_emergency_subtype_overdose_death"
  );

  const overdoseForm = $("#incident_report_form_overdose_section");

  toggleOverdoseSection();

  incidentTypeHasOverdose.on("change", () => {
    toggleOverdoseSection();
  });
  incidentTypeHasOverdoseDeath.on("change", () => {
    toggleOverdoseSection();
  });

  function toggleOverdoseSection() {
    if (incidentTypeHasOverdose.is(":checked") || incidentTypeHasOverdoseDeath.is(":checked")) {
      overdoseForm.show();
    } else {
      overdoseForm.hide();
    }
  }
};
